export const tipoFaltaInitialState = {
  tiposFaltas: [],
  novoTipoFalta: [],
  tipoFaltaRemovido: [],
  tipoFalta: [],
  tipoFaltaEditado: [],
  dropdownTiposFaltas: [],
};
